import {s3ImagesRootUrl} from "./components/_common/_constants";

export const s3ImageSource = (id: string, ext = "jpg", density = 3): string =>
  `${s3ImagesRootUrl}/${id}/${density}x.${ext}`;
